import i18n, { reloadResources } from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './en.json';
import hebTranslation from './heb.json';

const storedLang = localStorage.getItem('i18nextLng') || 'he';
document.documentElement.dir = storedLang === 'he' ? 'rtl' : 'ltr';
document.documentElement.lang = storedLang;

i18n.use(initReactI18next).init({
  debug: process.env.NODE_ENV === 'development',
  lng: storedLang,
  fallbackLng: 'he',
  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: ['localStorage', 'navigator'],
    lookupLocalStorage: 'i18nextLng',
    caches: ['localStorage'],
  },
  resources: {
    en: {
      translation: enTranslation,
    },
    he: {
      translation: hebTranslation,
    },
  },
});

i18n.on('languageChanged', (lng) => {
  document.documentElement.dir = lng === 'he' ? 'rtl' : 'ltr';
  document.documentElement.lang = lng;
  localStorage.setItem('i18nextLng', lng);
  reloadResources();
});

export default i18n;
